import { SubscriptionEntitlements } from '../../redux/slices/subscriptionSlice';

const SubscriptionUsage = ({ entitlements }: { entitlements: SubscriptionEntitlements | null }) => {
  if (!entitlements?.usage) return null;
  const { jobPosts, jobApplications } = entitlements.usage;
  return <section aria-label="Monthly allowance usage" style={{ marginTop: 16, lineHeight: 1.7 }}>
    <h3>Monthly allowance usage</h3>
    {[{ label: 'Job posts', quota: jobPosts }, { label: 'Job applications', quota: jobApplications }]
      .map(({ label, quota }) => <p key={label}>{label}: {quota.used} used · {quota.limit === null
        ? 'Unlimited' : `${quota.remaining} of ${quota.limit} remaining`}</p>)}
    {entitlements.allowanceResetsAt && <p>Resets: {new Date(entitlements.allowanceResetsAt)
      .toLocaleString('en-NG', { timeZone: 'Africa/Lagos' })} (WAT)</p>}
  </section>;
};

export default SubscriptionUsage;
